import { FC } from 'react';
import ProModal, { ModalProps } from './modal';
import ModalFunc, {
  modalGlobalConfig,
  ModalFuncProps,
  ModalFuncType,
} from './modalFunc';
import './style.less';

export type IModalComponent = FC<ModalProps> & {
  destroyAll: () => void;
  config: typeof modalGlobalConfig;
  info: ModalFuncType;
  success: ModalFuncType;
  error: ModalFuncType;
  warn: ModalFuncType;
  warning: ModalFuncType;
  confirm: ModalFuncType;
};

const TransProModal = ProModal as IModalComponent;
TransProModal.destroyAll = ModalFunc.destroyAll;
TransProModal.config = ModalFunc.config;
TransProModal.info = (params: ModalFuncProps) => ModalFunc.info(params);
TransProModal.success = (params: ModalFuncProps) => ModalFunc.success(params);
TransProModal.error = (params: ModalFuncProps) => ModalFunc.error(params);
TransProModal.warn = (params: ModalFuncProps) => ModalFunc.warn(params);
TransProModal.warning = (params: ModalFuncProps) => ModalFunc.warning(params);
TransProModal.confirm = (params: ModalFuncProps) => {
  const newParams: ModalFuncProps = {
    // getContainer: false,
    ...params,
  };
  return ModalFunc.confirm(newParams);
};

export default TransProModal;
